import React, {Component} from 'react';
import { Container} from 'reactstrap';
import {connect} from "react-redux";
import InfiniteScroll from 'react-infinite-scroller';

import * as actions from '../../actions/SearchActions';

import SearchHeader from '../../components/SearchHeader/SearchHeader'
import Spinner from '../../components/Spinner/Spinner'
import SearchResult from '../../components/SearchResult/SearchResult'
import Headline from "../../components/Headline/Headline";
import ErrorEmptyResult from "../../components/ErrorEmptyResult/ErrorEmptyResult";

class SearchContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            minimized: false,
            hasMore: true,
            query: null
        };

        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.selectAppointment = this.selectAppointment.bind(this);
        this.loadMoreAppointments = this.loadMoreAppointments.bind(this);
    }

    componentDidMount() {
        const {runSearch, updateQuery, updateFachgruppen, match} = this.props;

        const searchQuery = {
            when: match.params.when,
            where: match.params.where,
            what: match.params.what
        };

        this.setState({
            minimized: true,
            query: searchQuery
        });

        updateQuery(searchQuery);
        runSearch(searchQuery);
        updateFachgruppen();
    }

    handleSearchSubmit(searchQuery) {
        const {runSearch} = this.props;

        runSearch(searchQuery);
    }

    selectAppointment(item) {
        const {setCurrentResult, history} = this.props;

        setCurrentResult(item);
        history.push('/termin/' + item.appointments_id);
    }

    loadMoreAppointments() {
        const {loadMoreResults, results, results_loading, searchQuery} = this.props;

        if(!results_loading && searchQuery.what !== "") {
            loadMoreResults();
        }
    }

    render() {
        const {fachgruppen, searchQuery, results, results_loading, reachedResultsEnd} = this.props;
        const {minimized} = this.state;

        let currentFachgruppe = "";
        fachgruppen.forEach((item) => {
            if(item.id === parseInt(searchQuery.what)) {
                currentFachgruppe = item.singular;
            }
        });

        return (
            <div>
                <SearchHeader
                    searchQuery={searchQuery}
                    fachgruppen={fachgruppen}
                    searchSubmit={this.handleSearchSubmit}
                    minimized={minimized}
                />

                <Container>

                    <Headline pageTitle large>Ihre Suchergebnisse</Headline>

                    {
                        (!results_loading && results.length === 0) && <ErrorEmptyResult/>
                    }

                    {
                        results.length > 0 && <InfiniteScroll
                            pageStart={0}
                            loadMore={this.loadMoreAppointments}
                            hasMore={(!reachedResultsEnd)}
                            loader={<Spinner/>}
                        >
                            {
                                results.map((item) => {
                                    return <SearchResult data={item} fachgruppe={currentFachgruppe} clickAction={() => this.selectAppointment(item)}/>;
                                })
                            }
                        </InfiniteScroll>
                    }

                </Container>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        fachgruppen: state.fachgruppen,
        searchQuery: state.searchQuery,
        redirectedFromHome: state.redirectedFromHome,
        results: state.results,
        results_loading: state.results_loading,
        reachedResultsEnd: state.reachedResultsEnd
    };
}

export default connect(mapStateToProps, actions)(SearchContainer);



// WEBPACK FOOTER //
// ./src/container/public/SearchContainer.js